import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import WheelUsersList from './WheelUsersList';
import WheelPrizeSettings from './WheelPrizeSettings';
import WheelGeneralSettings from './WheelGeneralSettings';
import styles from './WheelTab.module.scss';

interface WheelTabProps {
  siteId: string | number;
}

const WheelTab: React.FC<WheelTabProps> = ({ siteId }) => {
  const [subTabValue, setSubTabValue] = useState(0);

  const handleSubTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSubTabValue(newValue);
  };

  return (
    <Box className={styles.container}>
      <Tabs
        value={subTabValue}
        onChange={handleSubTabChange}
        variant="scrollable"
        scrollButtons="auto"
        className={styles.subTabs}
        sx={{ mb: 4 }}
      >
        <Tab label="All lists" disableRipple />
        <Tab label="Prize settings" disableRipple />
        <Tab label="Settings" disableRipple />
      </Tabs>

      {subTabValue === 0 && <WheelUsersList siteId={siteId} />}
      {subTabValue === 1 && <WheelPrizeSettings siteId={siteId} />}
      {subTabValue === 2 && <WheelGeneralSettings siteId={siteId} />}
    </Box>
  );
};

export default WheelTab;
